"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var roles_exports = {};
__export(roles_exports, {
  DISTRICT_ADMIN_ROLE: () => DISTRICT_ADMIN_ROLE,
  GM_DCST_ROLE: () => GM_DCST_ROLE,
  GM_DIS_ROLE: () => GM_DIS_ROLE,
  GM_PS_ROLE: () => GM_PS_ROLE,
  NOT_ROLE_SELECTED: () => NOT_ROLE_SELECTED,
  SCHOOL_ADMIN_ROLE: () => SCHOOL_ADMIN_ROLE,
  TEACHER_ROLE: () => TEACHER_ROLE,
  getRoleInfo: () => getRoleInfo,
  rolesData: () => rolesData
});
module.exports = __toCommonJS(roles_exports);
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var TEACHER_ROLE = "teacher";
var DISTRICT_ADMIN_ROLE = "district-admin";
var SCHOOL_ADMIN_ROLE = "school-admin";
var GM_DIS_ROLE = "gm-dis";
var GM_DCST_ROLE = "gm-dcst";
var GM_PS_ROLE = "gm-ps";
var NOT_ROLE_SELECTED = void 0;
var rolesData = _defineProperty(_defineProperty(_defineProperty({}, DISTRICT_ADMIN_ROLE, {
  name: "dp_core_role_districtAdministrator",
  icon: "manage",
  dataDpAnalyticsId: "GlobalElementsGlobalRoleSwitcherSwitchToDistrictAdminButton"
}), SCHOOL_ADMIN_ROLE, {
  name: "dp_core_role_schoolAdministrator",
  icon: "school",
  dataDpAnalyticsId: "GlobalElementsGlobalRoleSwitcherSwitchToSchoolAdminButton"
}), TEACHER_ROLE, {
  name: "base_glossary_teacher_one",
  icon: "sections",
  dataDpAnalyticsId: "GlobalElementsGlobalRoleSwitcherSwitchToTeacherButton"
});
var getRoleInfo = function getRoleInfo2(roleId) {
  return rolesData[roleId] ? rolesData[roleId] : {
    name: "",
    icon: ""
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DISTRICT_ADMIN_ROLE,
  GM_DCST_ROLE,
  GM_DIS_ROLE,
  GM_PS_ROLE,
  NOT_ROLE_SELECTED,
  SCHOOL_ADMIN_ROLE,
  TEACHER_ROLE,
  getRoleInfo,
  rolesData
});
//# sourceMappingURL=roles.js.map